import React from 'react';
import { FaStar, FaClock, FaBuilding } from 'react-icons/fa';

// Tarjetas KPI de Contratos Menores (estilo 13a: acento verde arriba).
// Devuelve un fragmento con 3 tarjetas para que el grid de Principal las
// coloque junto a las 2 de Contratos Mayores en una sola fila de 5.
const IndicadoresMenores = ({ data, isLoading }) => {
  const card = {
    background: '#fff',
    border: '1px solid #e2e6ee',
    borderTop: '2px solid #0f766e',
    borderRadius: '11px',
    padding: '15px 16px',
    height: '100%',
    boxSizing: 'border-box'
  };

  if (isLoading) {
    return (
      <>
        {[...Array(3)].map((_, i) => (
          <div key={i} style={card}>
            <div style={{ width: '60%', height: 11, borderRadius: 4, background: '#eef1f5', animation: 'pulseCard 1.4s ease-in-out infinite' }} />
            <div style={{ width: '42%', height: 26, borderRadius: 5, background: '#eef1f5', marginTop: 13, animation: 'pulseCard 1.4s ease-in-out infinite' }} />
            <div style={{ width: '72%', height: 10, borderRadius: 4, background: '#eef1f5', marginTop: 11, animation: 'pulseCard 1.4s ease-in-out infinite' }} />
          </div>
        ))}
      </>
    );
  }

  const indicadores = [
    {
      label: 'Nuevas Convocatorias',
      value: data?.menores_nuevos ?? 0,
      icon: FaStar,
      sub: 'Publicadas hoy'
    },
    {
      label: 'Vigentes',
      value: data?.menores_vigentes ?? 0,
      icon: FaClock,
      sub: `${(data?.menores_proximas ?? 0).toLocaleString('es-PE')} vigentes`
    },
    {
      label: 'Cantidad de Entidades',
      value: data?.menores_entidad ?? 0,
      icon: FaBuilding,
      sub: `Que han publicado hoy`
    }
  ];

  return (
    <>
      {indicadores.map((ind, i) => {
        const Icon = ind.icon;
        const delay = `${(i * 0.04).toFixed(2)}s`;
        return (
          // El wrapper lleva la entrada (dvUp) para que no pise el translate del hover
          <div key={ind.label} style={{ animation: `dvUp .32s ease ${delay} both` }}>
            <div className="dash-kpi" style={card}>
              <div style={{ display: 'flex', alignItems: 'flex-start', gap: 10 }}>
                <span style={{ flex: 1, minWidth: 0, minHeight: 34, fontSize: '12.5px', fontWeight: 600, color: '#5b6779', lineHeight: 1.35 }}>
                  {ind.label}
                </span>
                <span style={{
                  width: 28,
                  height: 28,
                  borderRadius: 8,
                  background: '#f4f6f8',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0
                }}>
                  <Icon size={14} color="#a3abba" />
                </span>
              </div>
              <div style={{
                fontSize: '34px',
                fontWeight: 600,
                color: '#0f172a',
                letterSpacing: '-0.03em',
                lineHeight: 1,
                marginTop: '6px',
                animation: `dvFade .55s ease ${delay} both`
              }}>
                {Number(ind.value).toLocaleString('es-PE')}
              </div>
              <div style={{ fontSize: '12px', color: '#5b6779', marginTop: '9px' }}>{ind.sub}</div>
            </div>
          </div>
        );
      })}
    </>
  );
};

export default IndicadoresMenores;
